import { useRouter } from 'next/router';
import FootTC from '../comps/FootTC';
import A from './NewComps/A';
import B from './NewComps/B';
import C_PH from './NewComps/C_PH';
import B_NA from './NewComps/B_NA';
import C from './NewComps/C';
import D from './NewComps/D';
import E from './NewComps/E';
import F from './NewComps/F';
import G from './NewComps/G';
import H from './NewComps/H';
import I from './NewComps/I';
import J from './NewComps/J';
import K from './NewComps/K';
import L from './NewComps/L';
import M from './NewComps/M';
import N from './NewComps/N';
import O from './NewComps/O';
import P from './NewComps/P';
import Q from './NewComps/Q';
import R from './NewComps/R';
import AU1 from './AUComps/AU1';
import AU2 from './AUComps/AU2';
// import AU3 from './AUComps/AU3';
import AU4 from './AUComps/AU4';
import AU5 from './AUComps/AU5';
import AU6 from './AUComps/AU6';

import styles from './NewProductContent.module.scss';

export const PageComUPSAU = () => (
    <>
        <AU1 />
        <AU2 />
        {/* <AU3 /> */}
        <AU4 />
        <M />
        <AU5 />
        <D />
        <J />
        <AU6 />
        <N />
        <O />
        <Q />
        <FootTC />
    </>
);

export default function R3Page() {
    const { locale = 'us' } = useRouter();
    const IS_NA_SITES = ['us', 'ca', 'br', 'mx'].includes(locale);
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'kr', 'ph'].includes(locale);

    const PageComEU = () => (
        <>
            <A />
            {locale === 'ph' ? <B_NA /> : <B />}
            {locale === 'ph' && <C_PH />}
            <I />
            <G />
            <H />
            <J />
            <M />
            <C />
            <K />
            <L />
            <D />
            <E />
            <F />
            <N />
            <O />
            <Q />
            <R />
            {locale === 'kr' && <FootTC />}
        </>
    );
    const PageComNA = () => (
        <>
            <A />
            {['us', 'ca', 'br', 'mx'].includes(locale) ? <B_NA /> : <B />}
            <C />
            <D />
            <E />
            <F />
            <G />
            <H />
            <I />
            <J />
            <K />
            <L />
            <M />
            <N />
            <O />
            <P />
            <Q />
            <R />
        </>
    );

    return (
        <div className={`${styles.R3Page} R3Page`}>
            {IS_NA_SITES && <PageComNA />}
            {IS_EU_SITES && <PageComEU />}
        </div>
    );
}
